<template>
  <div class="enterprise-big-data-detail">
    <breadcrumb :breadcrumb="breadcrumb" />
    <!--<text-title :mainTitle="enterpriseData.name" style="border-left: 0;font-size: 20px;font-weight: 600;"/>-->
    <form>
      <div class="enterprise-big-data-line">
        <div class="enterprise-big-data-name">
          <div class="enterprise-big-data-info">{{enterpriseData.name}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">法定代表人：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.represent}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">注册资本：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.registerMoney}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">经营状态：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.status}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">所属地区：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.province}}{{enterpriseData.city}}{{enterpriseData.region}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">成立日期：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.buildDate}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">住户类型：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.type}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">统一社会信用代码：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.unicomCode}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">纳税人识别号：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.taxpayerNo}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">注册号：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.registerNo}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">组织机构代码：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.organizationCode}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">联系电话：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.contractPhone}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">参保人数：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.contributeNum}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">所属行业：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.involve}}</div>
        </div>
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title">经营范围：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.businessScope}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line" style="width: 600px;">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title" style="width: 120px">企业公示的地址：</div>
          <div class="enterprise-big-data-info">{{enterpriseData.address}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line" style="width: 600px;">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title" style="width: 120px">企业公示的邮箱：</div>
          <div class="enterprise-big-data-info" style="color: #31BEFB;">{{enterpriseData.email}}</div>
        </div>
      </div>
      <div class="enterprise-big-data-line" style="width: 600px;">
        <div class="enterprise-big-data-item">
          <div class="enterprise-big-data-title" style="width: 120px">企业公示的网址：</div>
          <a :href="enterpriseData.website" target="_blank" class="enterprise-big-data-info" style="color: #31BEFB;">{{enterpriseData.website}}</a>
        </div>
      </div>

      <div class="form-btn-box">
        <button-cancel @cancel="cancel" value="返回" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/Alarm'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'enterprise-big-data-detail',
    data () {
      return {
        breadcrumb: [{
          value: '企业大数据',
          name: 'enterprise-big-data'
        }, {
          value: '企业数据'
        }],
        mainTitle: '企业详情',
        subheading: '',

        buildingList: [],
        floorList: [],

        enterpriseData: {
          name: '', //住户名称
          represent: '', //法定代表人
          registerMoney: '', //注册资本
          buildDate: '', //成立日期
          status: '', //经营状态
          province: '', //所属省份
          city: '', //所属市区
          region: '', //所属区县
          type: '', //住户类型
          unicomCode: '', //统一社会信用代码

          taxpayerNo: '', //纳税人识别号
          registerNo: '', //注册号
          organizationCode: '', //组织机构代码
          contractPhone: '', //企业公示的联系电话
          otherPhone: '', //企业公示的联系电话（更多号码）
          contributeNum: '', //参保人数
          involve: '', //所属行业
          address: '', //企业公示的地址
          website: '', //企业公示的网址
          email: '', //企业公示的邮箱
          businessScope: '', //经营范围
        },

      }
    },
    created () {
      let enterpriseBigDataDetail = window.sessionStorage.getItem('enterpriseBigDataDetail')
      this.enterpriseData = JSON.parse(enterpriseBigDataDetail)
      for (let i in this.enterpriseData) {
        if (this.enterpriseData[i] === '--') {
          this.enterpriseData[i] = '无'
        }
      }

    },
    methods: {
      toManagePage () {
        this.$router.push({
          name: 'enterprise-big-data'
        })
      },

      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .enterprise-big-data-detail {
    .enterprise-big-data-name {
      font-size: 20px;
      font-weight: 600;
      margin: 40px 0 20px 0;
    }
    .enterprise-big-data-line {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 10px 0;
      .enterprise-big-data-item {
        width: 280px;
        margin: 10px 20px 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .enterprise-big-data-title {

        }
        .enterprise-big-data-info {
          flex: 1;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/EnterpriseBigData/EnterpriseBigData/EnterpriseBigDataDetail.vue